"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./ComponentIconPage"));



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconPage/index.ts
// module id = 682
// module chunks = 0